module.exports = __webpack_public_path__ + "img/Ventuar_Metal Halberd.0670640a.png";